import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useRef, createRef } from "react";
import { useTable, usePagination, useSortBy } from "react-table";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { faExclamationCircle, faHeart as solidHeart, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AdminNav from "../../../nav/AdminNav";
import { debounce } from "../../../../app/common/util/debounce";
import AdminSearchForm from "../../../forms/AdminSearchForm";
import CustomButton from "../../../../app/common/form/CustomButton";
import { useHistory } from "react-router";
import { openModal } from "../../../../app/common/modals/modalReducer";
import ReactTooltip from "react-tooltip";
import { toast, ToastContainer } from "react-toastify";
import { current } from "@reduxjs/toolkit";

// cart
import { getCartTotal } from "../../../nav/NavBar/cartActions";

export default function Cart(props) {
    let history = useHistory();
    const dispatch = useDispatch();
    const creditCardRef = useRef(null);
    const commentRef = useRef(null);
    //const inputRefs = new Map();
    const inputRefs = useRef(new Map());
    const debug = 0;

    const { currentUser } = useSelector((state) => state.auth);

    const [products, setProducts] = useState([]);
    const [freeProducts, setFreeProducts] = useState([]);
    // Promotion free items in the cart that are not set up in the customer's
    // branch warehouse - they can't be shown or ordered, so tell the customer.
    const [unavailableFree, setUnavailableFree] = useState({ items: [], sales_rep: null });
    // The debounced quantity handler is created once, so it must read cart
    // lines through refs - reading state gave it the first render's empty
    // free-item list forever, and every qty change reset the free line to 1.
    const productsRef = useRef([]);
    const freeProductsRef = useRef([]);
    const [cartTotal, setCartTotal] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [pageNumber, setPageNumber] = useState("0");
    const [cartHasPromo, setCartHasPromo] = useState(0);
    const [contactUser, setContactUser] = useState(false);
    const [specialQualify, setSpecialQualify] = useState([]);
    const [specialProducts, setSpecialProducts] = useState([]);
    const [scriptUploaded, setScriptUploaded] = useState(false);
    const [hasScript, setHasScript] = useState(false);
    const [totalFree, setTotalFree] = useState(0);
    const [first, setFirst] = useState(true);
    const [totalPrice, setTotalPrice] = useState("0");
    const [cashPayment, setCashPayment] = useState(false);
    const [paymentType, setPaymentType] = useState(currentUser.isCustomer === 1 ? 1 : 2);

    const [orderPlaced, setOrderPlaced] = useState(false);

    const [toUpdate, setToUpdate] = useState(false);

    const [totalToAccept, setTotalToAccept] = useState(0);
    const [totalAccepted, setTotalAccepted] = useState(0);

    const [reRunOrder, setReRunOrder] = useState(false);
    const [backorderAsk, setBackorderAsk] = useState(false);
    const [qtyIssue, setQtyIssue] = useState(false);
    const [salespeople, setSalespeople] = useState([]);
    const [payM8Privacy, setPayM8Privacy] = useState(true);
    const [termsCode, setTermsCode] = useState("0");
    const [currentBalance1, setCurrentBalance1] = useState(0);
    const [creditCardRequired, setCreditCardRequired] = useState(false);
    const [hasCredit, setHasCredit] = useState(false);
    const [creditAvailable, setCreditAvailable] = useState(0);
    const [uninvoiced, setUninvoiced] = useState(0);
    const [creditLeft, setCreditLeft] = useState(0);
    const [amountDue, setAmountDue] = useState(0);
    const [addedProd, setAddedProd] = useState(false);


    // Modal and Progress State
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [progress, setProgress] = useState({
        checkingStock: { status: "idle", message: "Confirming Stock Availability" },
        placingOrder: { status: "idle", message: "Placing Order" },
        sendingEmail: { status: "idle", message: "Sending Email" },
    });
    const [importData, setImportData] = useState(null);
    const [isImportModalVisible, setImportModalVisible] = useState(false);

    //Check if we have a token in the url, this means we have a successful payment
    const location = useLocation();

    useEffect(
        () => {
            async function fetchData() {
                getProducts(0);
                setCartTotal(parseFloat(window.sessionStorage.getItem("itemsInBasket")));

                if (reRunOrder === true) {
                    PlaceThisOrder([products, freeProducts].flat(), window.sessionStorage.getItem("po_no"), totalPrice, amountDue, window.sessionStorage.getItem("salesperson"));
                    setReRunOrder(false);
                }

                console.log(currentUser);

                if ((currentUser.isLakato === 1 || currentUser.isAdmin === 1) && salespeople.length === 0) {
                    let salesResp = await axios({
                        method: "post",
                        url: `${process.env.REACT_APP_API_URL}get_salespeople`,
                        headers: { Authorization: `Bearer ${currentUser.token}` },
                    });

                    setSalespeople(salesResp.data);
                }
            }

            fetchData();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [reRunOrder]
    );

    useEffect(
        () => {
            // TODO: investigate why product on promo do not show in second grid
            async function fetchData() {
                //Promos
                //Get active promotions
                let promoResults = await axios({
                    method: "post",
                    url: `${process.env.REACT_APP_API_URL}active-specials`,
                    headers: { Authorization: `Bearer ${currentUser.token}` },
                    data: {
                        customer_code:
                            currentUser.isCustomer === 1 && currentUser.customer_code !== null
                                ? currentUser.customer_code
                                : currentUser.customer_code === null || currentUser.customer_code.split(",").length > 1
                                    ? "None"
                                    : currentUser.customer_code,
                    },
                });
                let promoData = promoResults.data;

                let qualify = [];
                let qualifyId = [];

                let toAccept = 0;

                for (const key of Object.keys(promoData)) {
                    const promo = promoData[key];
                    const promoItems = promo.items;
                    const allRules = promo.rules;

                    // Check if any of the promo items are in the cart
                    const isPromoItemInCart = Object.keys(promoItems).some((index) => {
                        const promoItem = promoItems[index];
                        return products.some((cartItem) => cartItem.col0 === promoItem.product_stock_code);
                    });

                    if (isPromoItemInCart && promo.accept_terms === 1 && freeProducts.length > 0) {
                        toAccept += 1; // Increment toAccept counter if a promo item is in the cart and accept_terms is 1
                    }

                    for (const no of Object.keys(allRules)) {
                        for (const index of Object.keys(promoItems)) {
                            const currentPromoItem = promoItems[index];
                            if (currentPromoItem.product_type === 1 && products.includes(currentPromoItem.product_stock_code)) {
                                qualifyId.push({
                                    prodcustId: currentPromoItem.product_stock_code,
                                    promoID: promo.id,
                                    discount_type: promo.discount_type,
                                    discount_percentage: promo.discount_percentage,
                                    free_amount: promo.free_amount,
                                    promotionType: allRules[no].rule_type,
                                    rule_size: allRules[no].rule_size,
                                    rule_qty: allRules[no].rule_qty,
                                    accept_terms: promo.accept_terms,
                                });
                            }
                        }
                    }
                }

                setTotalToAccept(toAccept);
                setSpecialQualify(qualify);
            }

            // Fetch data only when products and freeProducts have meaningful changes
            if (products.length > 0 || freeProducts.length > 0) {
                fetchData();
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [products, freeProducts]
    );

    async function createTemplate(orderItems) {
        dispatch(
            openModal({
                modalType: "TemplateName",
                modalProps: { orderItems: orderItems },
            })
        );
    }
    // TODO: investigate why product on promo do not show in second grid
    async function getProducts(time) {
        debug && debug === 1 && console.log("getProducts");
        setOrderPlaced(true);
        setHasScript(false);

        const searchParams = new URLSearchParams(location.search);
        const token = searchParams.get("token");

        let cartItems = await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}get-items-in-cart`,
            headers: { Authorization: `Bearer ${currentUser.token}` },
            data: {
                id: currentUser.id,
                priceCode:
                    currentUser.isCustomer === 1 && currentUser.customer_code !== null
                        ? currentUser.customer_code
                        : currentUser.customer_code === null || currentUser.customer_code.split(",").length > 1
                            ? "None"
                            : currentUser.customer_code,
                branch: currentUser.branch,
                customer_code: currentUser.customer_code,
            },
        });

        if (!token) {
            let termscode = cartItems.data[4].TermsCode ? parseInt(cartItems.data[4].TermsCode) : 1;
            if (termscode === 2 && currentUser.isCustomer === 1) {
                // if (termscode === 2) { //This is to test if you log in as someone for cash
                setCashPayment(true);

                setProgress((prevProgress) => ({
                    ...prevProgress,
                    cashPayment: { status: "idle", message: "Processing Cash Payment" },
                }));
            }
        }

        let newPrevItemIds = [];

        await Object.keys(cartItems).forEach(function (key) {
            newPrevItemIds.push(cartItems[key].stock_code);
        });

        //Get items in basket
        let productResults = await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}get-favourite-products`,
            headers: { Authorization: `Bearer ${currentUser.token}` },
            data: {
                userId: currentUser.id,
                priceCode:
                    currentUser.isCustomer === 1 && currentUser.customer_code !== null
                        ? currentUser.customer_code
                        : currentUser.customer_code === null || currentUser.customer_code.split(",").length > 1
                            ? "None"
                            : currentUser.customer_code,
                category: "",
                favIds: newPrevItemIds,
            },
        });
        let prodData = productResults.data;

        let allproducts = [];
        let secondProds = [];
        // let alreadyQualify = [];

        let allcartItems = cartItems.data[0];
        let totalsCartItems = cartItems.data[1];
        let prodDataSpecial = cartItems.data[2];
        let prodDataSubCode = cartItems.data[3];
        setUnavailableFree(cartItems.data[5] && Array.isArray(cartItems.data[5].items) ? cartItems.data[5] : { items: [], sales_rep: null });

        let allCodes = [];

        prodDataSubCode.forEach(function (subCode) {
            allCodes.push(subCode.stock_code);
        });

        let totalPriceAccum = 0;

        let LineNumber = 1;
        await Object.keys(allcartItems).forEach(async function (key) {
            if (allcartItems[key].ProductGroup == "PG008" && allcartItems[key].UserField3 == "6") {
                setHasScript(true);
            }

            let totals = 0;
            await Object.keys(totalsCartItems).forEach(async function (index) {
                if (totalsCartItems[index].stock_code === allcartItems[key].StockCode) {
                    totals = totalsCartItems[index].qty;
                }
            });

            let display = "";

            if (prodDataSubCode.length > 0 && allCodes.includes(allcartItems[key].StockCode)) {
                prodDataSubCode.forEach(function (subCode) {
                    if (subCode.stock_code == allcartItems[key].StockCode) {
                        display = subCode.custom_code;
                    }
                });
            }

            let promoId = [];
            let promoArr = [];

            let promoType = [];
            let promoOnType = [];
            let promoAmountType = [];
            let promoAmount = [];
            let promoDiscountAmount = [];
            let promoFreeAmount = [];
            let applyTerms = [];

            const currentCartItemCode = allcartItems[key].StockCode;

            // Build a quick qty lookup for qualifying checks
            const cartQtyByStock = {};
            totalsCartItems.forEach((item) => {
                cartQtyByStock[item.stock_code] = item.qty;
            });

            const promoMatches = [];

            prodDataSpecial.forEach(function (promo) {
                const items = promo.items || [];

                let itemType = null;
                items.forEach(function (item) {
                    if (item.product_stock_code === currentCartItemCode) {
                        if (item.product_type == "1") {
                            itemType = "yes";
                        } else if (item.product_type == "2") {
                            itemType = "free";
                        }
                    }
                });

                if (!itemType) {
                    return;
                }

                const requiredItems = items
                    .filter((item) => item.product_type == "1")
                    .map((item) => item.product_stock_code);

                let totalInCart = 0;
                requiredItems.forEach((code) => {
                    totalInCart += cartQtyByStock[code] || 0;
                });

                const rule = promo.rules && promo.rules[0] ? promo.rules[0] : null;
                const ruleQty = rule ? rule.rule_qty : 0;
                const ruleType = rule ? rule.rule_type : null;
                const ruleSize = rule ? rule.rule_size : null;
                let qualifies = false;

                if (requiredItems.length > 0 && ruleType == 2) {
                    if (ruleSize == 2) {
                        qualifies = totalInCart === ruleQty;
                    } else if (ruleSize == 3) {
                        qualifies = totalInCart >= ruleQty;
                    } else {
                        qualifies = totalInCart >= ruleQty;
                    }
                }

                promoMatches.push({
                    promo,
                    itemType,
                    qualifies,
                    totalInCart,
                });
            });

            // Prefer a promo that actually qualifies for this cart
            let chosenPromo = promoMatches.find((match) => match.itemType === "free" && match.qualifies);
            if (!chosenPromo) {
                chosenPromo = promoMatches.find((match) => match.itemType === "yes" && match.qualifies);
            }
            if (!chosenPromo && promoMatches.length > 0) {
                const anyFree = promoMatches.find((match) => match.itemType === "free");
                chosenPromo = anyFree || promoMatches[0];
            }

            if (chosenPromo) {
                promoArr.push(chosenPromo.itemType);
                promoId.push(chosenPromo.promo.id);
                promoType.push(chosenPromo.promo.discount_type);
                const chosenRule = chosenPromo.promo.rules && chosenPromo.promo.rules[0] ? chosenPromo.promo.rules[0] : {};
                promoOnType.push(chosenRule.rule_type ?? null);
                promoAmountType.push(chosenRule.rule_size ?? null);
                promoAmount.push(chosenRule.rule_qty ?? 0);
                promoDiscountAmount.push(chosenPromo.promo.discount_percentage);
                promoFreeAmount.push(chosenPromo.promo.free_amount);
                applyTerms.push(chosenPromo.promo.accept_terms);
                setCartHasPromo(1);
            }

            let acceptTnc = "no";
            let acceptTncArr = [];
            let acceptedPromotions = JSON.parse(window.sessionStorage.getItem("promotionAccepted"));

            if (acceptedPromotions !== null) {
                acceptedPromotions.forEach(function (accept) {
                    if (accept == allcartItems[key].StockCode) {
                        acceptTncArr.push("yes");
                    }
                });
            }

            if (acceptTncArr[0] === "yes") {
                acceptTnc = "yes";
            }

            let cartData = {
                col0: allcartItems[key].StockCode,
                col1: allcartItems[key].col1,
                col2: allcartItems[key].StockCode,
                col3: allcartItems[key].Description,
                col4: allcartItems[key].InvWarehouse,
                col5: allcartItems[key].SellingPrice ? "R " + parseFloat(allcartItems[key].SellingPrice).toFixed(2) : "Free",
                col6: totals,
                col8: allcartItems[key].LongDesc,
                col10: allcartItems[key].ProductGroup,
                col11: allcartItems[key].AlternateUom,
                col12: promoArr[0],
                col13: promoId[0],
                col14: promoType[0],
                col15: promoOnType[0],
                col16: promoAmountType[0],
                col17: promoAmount[0],
                col18: promoDiscountAmount[0],
                col19: promoFreeAmount[0],
                col20: acceptTnc,
                col21: allcartItems[key].UserField3,
                col22: applyTerms[0],
                col23: allcartItems[key].special_prices !== "" && allcartItems[key].special_prices !== null ? "R " + parseFloat(allcartItems[key].special_prices).toFixed(2) : "",
                col24: display,
                col25: allcartItems[key].backorder,
                col26: LineNumber,
            };

            let price = parseFloat(allcartItems[key].SellingPrice).toFixed(2);
            if (allcartItems[key].special_prices !== "" && allcartItems[key].special_prices !== null) {
                price = parseFloat(allcartItems[key].special_prices).toFixed(2);
            }

            // console.log(totalPriceAccum, price, totals);

            totalPriceAccum = totalPriceAccum + price * totals;

            allproducts.push(cartData);
            LineNumber = LineNumber + 1;
        });


        const availableCreditResult = await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}get-customer-credit`,
            headers: { Authorization: `Bearer ${currentUser.token}` },
            data: {
                userId: currentUser.id,
                customer_code: currentUser.customer_code
            },
        });

        const terms = availableCreditResult?.data?.credit?.TermsCode.trim();
        const currentBalance = parseFloat(availableCreditResult?.data?.credit?.CurrentBalance1).toFixed(2);
        const totalUninvoiced = parseFloat(availableCreditResult?.data?.totalUninvoiced) * 1.15;
        setTermsCode(terms);
        setCurrentBalance1(currentBalance);
        setUninvoiced(totalUninvoiced.toFixed(2));
        setOrderPlaced(false);
        //logic for credit card payment
        // follow normal if not terms code 2
        // if terms code 2 and has credit, then show credit card payment

        if (availableCreditResult && terms == "2") {
            const availableCredit = currentBalance < 0 ? Math.abs(currentBalance) : 0;
            setHasCredit(availableCredit - totalUninvoiced > 0);
            const purchaseExclVat = parseFloat(totalPriceAccum);
            const purchaseIncVat = purchaseExclVat * 1.15;

            const uninvoiced = parseFloat(availableCreditResult.data.totalUninvoiced);
            const uninvoicedIncVat = uninvoiced * 1.15;

            const currentOrderIncVat = purchaseIncVat;

            // Total of what still needs to be charged (uninvoiced + this order)
            const totalExposure = uninvoicedIncVat + currentOrderIncVat;

            // console.log('Available Credit:', availableCredit);
            // console.log('Total Exposure:', totalExposure);

            let credits = 0;
            let creditCardRequired = false;
            let creditApplied = 0;
            let dueAmount = purchaseIncVat;
            if (totalExposure <= availableCredit) {
                credits = availableCredit - totalExposure; // full order covered
                creditApplied = Math.min(availableCredit, currentOrderIncVat);
                dueAmount = 0;
                creditCardRequired = false;
            } else {
                // Determine how much of this current order can still be covered
                const remainingCreditAfterUninvoiced = availableCredit - uninvoicedIncVat;
                const coverableFromCreditExVat = remainingCreditAfterUninvoiced / 1.15;
                credits = remainingCreditAfterUninvoiced > 0 ? coverableFromCreditExVat : 0;
                dueAmount = purchaseExclVat - credits;
                creditApplied = remainingCreditAfterUninvoiced > 0
                    ? Math.min(currentOrderIncVat, remainingCreditAfterUninvoiced)
                    : 0;
                creditCardRequired = true;


            }
            // console.log('credits:', credits);
            // console.log('purchaseExclVat:', purchaseExclVat);
            // console.log('availableCredit:', availableCredit);
            // console.log('creditApplied:', creditApplied);
            // console.log('dueAmount:', dueAmount);
            // console.log('creditCardRequired:', creditCardRequired);

            setTotalPrice(purchaseExclVat.toFixed(2));       // without VAT
            setCreditAvailable(availableCredit.toFixed(2));
            setCreditLeft(creditApplied.toFixed(2));
            setAmountDue(parseFloat(dueAmount * 1.15).toFixed(2));
            setCreditCardRequired(creditCardRequired);

        } else {
            setHasCredit(false);
            setTotalPrice(parseFloat(totalPriceAccum).toFixed(2));
            setAmountDue(parseFloat(totalPriceAccum * 1.15).toFixed(2));
        }

        let allNormalProds = [];
        let allFreeProds = [];
        let new_allprods = allproducts;

        await Object.keys(allproducts).forEach(async function (key) {
            let reqBuyTotal = "";

            if (allproducts[key].col12 == "free") {
                let itemsIncartForPromo = [];
                await Object.keys(prodDataSpecial).forEach(async function (promo) {
                    let specialId = allproducts[key].col13;
                    let items = prodDataSpecial[promo].items;
                    const promoRules = prodDataSpecial[promo].rules;

                    await Object.keys(items).forEach(async function (index) {
                        if (items[index].product_type == "1" && prodDataSpecial[promo].id == specialId) {
                            itemsIncartForPromo.push(items[index].product_stock_code);
                            const firstRule = promoRules && promoRules[0] ? promoRules[0] : null;
                            reqBuyTotal = firstRule ? firstRule.rule_qty : null;
                        }
                    });
                });

                let result = allproducts.map(({ col2 }) => col2);
                let found = result.some((r) => itemsIncartForPromo.includes(r));

                let totalInCart = 0;

                new_allprods.forEach(function (prod) {
                    if (itemsIncartForPromo.includes(prod.col2)) {
                        totalInCart += prod.col6;
                    }
                });

                if (found == true && reqBuyTotal !== null && totalInCart >= reqBuyTotal) {
                    allFreeProds.push(allproducts[key]);
                } else {
                    allNormalProds.push(allproducts[key]);
                }
            } else {
                allNormalProds.push(allproducts[key]);
            }
        });

        productsRef.current = allNormalProds;
        freeProductsRef.current = allFreeProds;
        setProducts(allNormalProds);
        setFreeProducts(allFreeProds);

        if (time === 0) {
            reconcileFreeItems(allNormalProds);
        }
        setSpecialProducts(secondProds);


        debug && debug === 1 && console.log(allproducts);
        debug && debug === 1 && console.log(allNormalProds);
        debug && debug === 1 && console.log(allFreeProds);
        debug && debug === 1 && console.log(secondProds);

        //Check if we have any products with a 0 qty

        let qtyOK = true;
        Object.keys(allNormalProds).forEach(function (key) {
            if (allNormalProds[key].col6 <= 0) {
                qtyOK = false;
            }
        });

        if (qtyOK === false) {
            setQtyIssue(true);
        } else {
            setQtyIssue(false);
        }

        if (first === true) {
            setFirst(false);
        }

        //Now check if we need to redo the order after cash payment

        if (token) {
            if (token === "error" || token === "nopayment") {
                alert("We have received your order but something went wrong with the payment. Contact Lakato to arrange payment.");
            } else {
                setCashPayment(false);
            }
        }


    }

    async function RemovePromoItemFromCart(itemId, promoId) {
        let prevPromoItems = JSON.parse(window.sessionStorage.getItem("promotionItemsInCart"));

        let newPromo = [];
        if (prevPromoItems && prevPromoItems.length > 0) {
            await Object.keys(prevPromoItems).forEach(function (key) {
                if (prevPromoItems[key][2] !== promoId) {
                    newPromo.push(prevPromoItems[key]);
                }
            });
        }

        window.sessionStorage.setItem("promotionItemsInCart", JSON.stringify(newPromo));

        //Get the product that we are removing, we need to also remove the linked promo item
        if (cartHasPromo == 1) {
            await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}remove-items-from-cart`,
                headers: { Authorization: `Bearer ${currentUser.token}` },
                data: {
                    StockCode: itemId,
                    id: currentUser.id,
                    customer_code: currentUser.customer_code,
                    remove_promo_item: 1,
                },
            });
        }

        await RemoveItemFromCart(itemId);

        dispatch(getCartTotal(currentUser));
    }

    async function emptyCart() {
        setOrderPlaced(true);
        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}remove-all-items-from-cart`,
            headers: { Authorization: `Bearer ${currentUser.token}` },
            data: {
                userId: currentUser.id,
                customer_code: currentUser.customer_code,
            },
        }).then(async (data) => {
            console.log(data);
            let CurrentCartAmount = window.sessionStorage.getItem("itemsInBasket");
            let NewAmount = parseFloat(CurrentCartAmount) - 1;
            window.sessionStorage.setItem("itemsInBasket", NewAmount);
            // await getProducts(1);
            // dispatch(getCartTotal(currentUser));
            // setOrderPlaced(false);
            window.location.reload();
        }).catch((err) => {
            console.log(err);
            setOrderPlaced(false);
        });

    }

    async function RemoveItemFromCart(itemId) {
        itemId = itemId.trim();
        setOrderPlaced(true);

        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}remove-items-from-cart`,
            headers: { Authorization: `Bearer ${currentUser.token}` },
            data: {
                StockCode: itemId,
                id: currentUser.id,
                customer_code: currentUser.customer_code,
            },
        });

        let CurrentCartAmount = window.sessionStorage.getItem("itemsInBasket");
        let NewAmount = parseFloat(CurrentCartAmount) - 1;
        window.sessionStorage.setItem("itemsInBasket", NewAmount);

        await getProducts(1);

        dispatch(getCartTotal(currentUser));
        setOrderPlaced(false);
    }
    // update cart item quantity then reload the cart
    const debouncedUpdate = useRef(
        debounce(async (rowInfo, totalAmount) => {
            const itemId = rowInfo.col2.trim();

            //console.log(itemId, rowInfo, totalAmount);

            if (rowInfo.col12 === "yes" && rowInfo.col14 === "2") {
                try {
                    await updateFreeInfo(totalAmount, itemId, rowInfo);
                } catch (err) {
                    console.error("Free item update failed:", err);
                }
            }

            try {
                await axios({
                    method: "post",
                    url: `${process.env.REACT_APP_API_URL}update-qty-in-cart`,
                    headers: { Authorization: `Bearer ${currentUser.token}` },
                    data: {
                        StockCode: itemId,
                        id: currentUser.id,
                        qty: totalAmount,
                        customer_code: currentUser.customer_code,
                    },
                }).then(async (data) => {
                    //console.log('********************', data);
                    await getProducts(1);
                }).catch((err) => {
                    console.log(err);
                    setOrderPlaced(false);
                });
            } catch (err) {
                console.error("Update failed:", err);
            }
        }, 600) // debounce delay
    ).current;

    // Buy-N-get-M promos repeat: every full N of the promo's qualifying
    // items earns M free (buy 2 get 1 -> 4 earns 2, 6 earns 3). The backend
    // posts whatever quantity the free cart line holds, so this is where the
    // booked-out free quantity is decided.
    function freeQtyFor(qualifyingQty, buyQty, freeAmount) {
        if (!(buyQty > 0)) {
            return 0;
        }
        return Math.floor(qualifyingQty / buyQty) * (freeAmount > 0 ? freeAmount : 1);
    }

    // Returns true when the cart was changed (caller decides on a reload).
    async function updateFreeInfo(totalAmount, itemId, rowInfo) {
        if (rowInfo.col12 !== "yes" || String(rowInfo.col14) !== "2") {
            return false;
        }

        const promoId = rowInfo.col13;
        const buyQty = parseFloat(rowInfo.col17);
        const freeAmount = parseFloat(rowInfo.col19);
        if (!promoId || !(buyQty > 0)) {
            return false;
        }

        const editedCode = String(itemId).trim();
        let qualifyingQty = 0;
        let sawEdited = false;
        productsRef.current.forEach((line) => {
            if (line.col12 === "yes" && line.col13 === promoId) {
                if (String(line.col2).trim() === editedCode) {
                    sawEdited = true;
                    qualifyingQty += parseFloat(totalAmount) || 0;
                } else {
                    qualifyingQty += parseFloat(line.col6) || 0;
                }
            }
        });
        if (!sawEdited) {
            qualifyingQty += parseFloat(totalAmount) || 0;
        }

        const desiredFree = freeQtyFor(qualifyingQty, buyQty, freeAmount);

        // A free line drops out of freeProducts once it stops qualifying,
        // so look for it in both lists.
        const existingFree = [...freeProductsRef.current, ...productsRef.current].filter(
            (line) => line.col12 === "free" && line.col13 === promoId
        );

        let changed = false;

        if (existingFree.length > 0) {
            for (const line of existingFree) {
                const freeCode = String(line.col2).trim();
                if (desiredFree > 0) {
                    if (parseFloat(line.col6) !== desiredFree) {
                        await axios({
                            method: "post",
                            url: `${process.env.REACT_APP_API_URL}update-qty-in-cart`,
                            headers: { Authorization: `Bearer ${currentUser.token}` },
                            data: {
                                StockCode: freeCode,
                                id: currentUser.id,
                                qty: desiredFree,
                                customer_code: currentUser.customer_code,
                            },
                        });
                        changed = true;
                    }
                } else {
                    await axios({
                        method: "post",
                        url: `${process.env.REACT_APP_API_URL}remove-items-from-cart`,
                        headers: { Authorization: `Bearer ${currentUser.token}` },
                        data: {
                            StockCode: freeCode,
                            id: currentUser.id,
                            customer_code: currentUser.customer_code,
                        },
                    });
                    changed = true;
                }
            }
        } else if (desiredFree > 0) {
            const activeSpecial = await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}special-details`,
                headers: { Authorization: `Bearer ${currentUser.token}` },
                data: { promotionID: promoId },
            });

            const specialItems = Object.values(activeSpecial.data.items || {});
            for (const item of specialItems) {
                const freeCode = String(item.product_stock_code || "").trim();
                // Cart lines are keyed by stock code: a free item sharing the
                // paid item's code would overwrite the paid quantity.
                if (item.product_type != "2" || freeCode === "" || freeCode === editedCode) {
                    continue;
                }
                await axios({
                    method: "post",
                    url: `${process.env.REACT_APP_API_URL}add-items-to-cart`,
                    headers: { Authorization: `Bearer ${currentUser.token}` },
                    data: {
                        StockCode: freeCode,
                        id: currentUser.id,
                        qty: desiredFree,
                        auto: 1,
                        customer_code: currentUser.customer_code,
                    },
                });
                changed = true;
            }
        }

        if (changed) {
            setToUpdate((prev) => !prev);
            dispatch(getCartTotal(currentUser));
        }

        return changed;
    }

    // Initial cart load: bring every free-item promo's free line in line
    // with the quantities already in the cart (once per promo).
    async function reconcileFreeItems(normalLines) {
        const seenPromos = new Set();
        let changed = false;
        for (const line of normalLines) {
            if (line.col12 !== "yes" || String(line.col14) !== "2" || !line.col13 || seenPromos.has(line.col13)) {
                continue;
            }
            seenPromos.add(line.col13);
            try {
                if (await updateFreeInfo(line.col6, line.col2, line)) {
                    changed = true;
                }
            } catch (err) {
                console.error("Free item reconcile failed:", err);
            }
        }
        if (changed) {
            await getProducts(1);
        }
    }

    async function openPromo(value) {
        let activeSpecial = await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}special-details`,
            headers: {
                Authorization: `Bearer ${currentUser.token}`,
            },
            data: { promotionID: value },
        });

        let specialData = [activeSpecial.data];
        let specialInfo = [];

        await Object.keys(specialData).forEach(async function (key) {
            let loopItems = specialData[key].items;
            let products = [];
            let free = [];

            await Object.keys(loopItems).forEach(async function (index) {
                if (loopItems[index].product_type == "1") {
                    products.push(loopItems[index].product_stock_code);
                }
                if (loopItems[index].product_type == "2") {
                    free.push(loopItems[index].product_stock_code);
                }
            });

            specialInfo.push({
                col0: specialData[key].id,
                col1: specialData[key].promotion_name,
                col2: specialData[key].from_date,
                col3: specialData[key].to_date,
                col4: specialData[key].discount_type,
                col5: specialData[key].free_amount,
                col6: specialData[key].discount_percentage,
                col7: specialData[key].special_type,
                col8: specialData[key].req_buy_amount,
                col9: specialData[key].free_product_type,
                col9: specialData[key].limit_on_order,
                col10: specialData[key].limit_per_day,
                col11: products,
                col12: free,
                col13: specialData[key].special_on,
                col14: specialData[key].ProductsGroup,
                col15: specialData[key].rules,
                col16: specialData[key].file_url,
                col17: specialData[key].promo_desc,
            });
        });

        dispatch(
            openModal({
                modalType: activeSpecial.data.discount_type == "1" ? "PromotionDiscount" : "PromotionFree",
                modalProps: { Promotion: specialInfo[0] },
            })
        );
    }

    function ProgressModal({ isVisible, progress }) {
        if (!isVisible) return null;

        return (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
                <div className="bg-white rounded-lg shadow-lg p-6 w-96">
                    <h2 className="text-lg font-semibold mb-4 text-gray-800">Processing Order</h2>
                    <ul className="space-y-4">
                        {Object.keys(progress).map((key) => (
                            <li key={key} className="flex items-center space-x-4">
                                <div>
                                    {/* Spinner, Checkmark, or Error Icon */}
                                    {progress[key].status === "in-progress" && <div className="w-5 h-5 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>}
                                    {progress[key].status === "completed" && (
                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                        </svg>
                                    )}
                                    {progress[key].status === "failed" && (
                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    )}
                                </div>
                                <p className={`text-sm ${progress[key].status === "completed" ? "text-green-600" : progress[key].status === "failed" ? "text-red-600" : "text-gray-700"}`}>
                                    {progress[key].message}
                                </p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }

    function ImportModal({ isVisible, importData, onClose }) {
        if (!isVisible) return null;

        return (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-20">
                <div className="bg-white rounded-lg shadow-lg p-6 w-96">
                    <h2 className="text-lg font-semibold mb-4 text-gray-800">Import Results</h2>

                    {importData.status === "success" ? (
                        <p className="text-green-600 font-medium">Import completed successfully!</p>
                    ) : (
                        <ul className="space-y-4">
                            {importData.not_found?.length > 0 && (
                                <li>
                                    <h3 className="text-red-500 font-semibold">Not Found Stock Codes:</h3>
                                    <ul className="list-disc ml-5 text-sm text-red-600">
                                        {importData.not_found.map((item, index) => (
                                            <li key={index}>Row {item.row}: {item.stock_code}</li>
                                        ))}
                                    </ul>
                                </li>
                            )}
                            {importData.quantity_errors?.length > 0 && (
                                <li>
                                    <h3 className="text-yellow-500 font-semibold">Quantity Issues:</h3>
                                    <ul className="list-disc ml-5 text-sm text-yellow-600">
                                        {importData.quantity_errors.map((item, index) => (
                                            <li key={index}>Row {item.row}: {item.stock_code} (Qty: {item.qty})</li>
                                        ))}
                                    </ul>
                                </li>
                            )}
                        </ul>
                    )}

                    <button
                        onClick={onClose}
                        className="inline-flex w-full items-center justify-center mt-2 px-12 py-2 border border-transparent text-base font-medium border_radius_4 shadow-sm text-white bg-lk_red hover:bg-lk_red_hover uppercase"
                    >
                        Close
                    </button>
                </div>
            </div>
        );
    }

    const data = React.useMemo(() => products, [products]);

    const columns = React.useMemo(
        () => [
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "left",
                        }}
                    >
                        #
                    </div>
                ),
                accessor: "col26",
            },
            {
                Header: ({ column }) => (
                    <div className="flex items-center cursor-pointer" {...column.getSortByToggleProps()}>
                        Code
                        <span className="ml-1">
                            {column.isSorted ? (column.isSortedDesc ? "▼" : "▲") : "▲▼"}
                        </span>
                    </div>
                ),
                accessor: "col2",
                Cell: (rowInfo) => {
                    return (
                        <>
                            {rowInfo.row.original.col2}
                            {rowInfo.row.original.col24 !== "" && (
                                <>
                                    <br />
                                    {rowInfo.row.original.col24}
                                </>
                            )}
                        </>
                    );
                },
            },
            {
                Header: ({ column }) => (
                    <div className="flex items-center cursor-pointer" {...column.getSortByToggleProps()}>
                        Description
                        <span className="ml-1">
                            {column.isSorted ? (column.isSortedDesc ? "▼" : "▲") : "▲▼"}
                        </span>
                    </div>
                ),
                accessor: "col3",
                Cell: (rowInfo) => {
                    return (
                        <>
                            <span>{rowInfo.row.original.col3}</span>
                            <br />
                            <span>{rowInfo.row.original.col8}</span> &nbsp;&nbsp;
                            <span className="text-red-500">
                                {rowInfo.row.original.col10 == "PG008" || rowInfo.row.original.col10 == "PG003" || rowInfo.row.original.col10 == "PG007" || rowInfo.row.original.col10 == "PG001" ? (
                                    <>
                                        {/* <br/>  */}
                                        {rowInfo.row.original.col10 == "PG008" ? (
                                            <>
                                                <span data-tip="NON-RETURNABLE. This is a product registered under the Medicines and Related Substance Act 101 of 1965 as Schedule 6 and requires a prescription to be submitted to Lakato. This product is non-returnable">
                                                    <FontAwesomeIcon icon={faQuestionCircle} />
                                                </span>{" "}
                                                <ReactTooltip />
                                            </>
                                        ) : (
                                            ""
                                        )}

                                        {rowInfo.row.original.col10 == "PG003" || rowInfo.row.original.col10 == "PG007" ? (
                                            <>
                                                <span data-tip="NON-RETURNABLE. This is a cold-chain product and is non-returnable">
                                                    <FontAwesomeIcon icon={faQuestionCircle} />
                                                </span>{" "}
                                                <ReactTooltip />
                                            </>
                                        ) : (
                                            ""
                                        )}

                                        {rowInfo.row.original.col10 == "PG001" ? (
                                            <>
                                                <span data-tip="NON-RETURNABLE. This product registered under the Medicines and Related Substance Act 101 of 1965 and is non-returnable">
                                                    <FontAwesomeIcon icon={faQuestionCircle} />
                                                </span>{" "}
                                                <ReactTooltip />
                                            </>
                                        ) : (
                                            ""
                                        )}
                                    </>
                                ) : (
                                    ""
                                )}
                            </span>
                        </>
                    );
                },
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "left",
                        }}
                    >
                        Stock Status
                    </div>
                ),
                accessor: "col4",
                Cell: (rowInfo) => {
                    return (
                        <>
                            {rowInfo.row.original.col4 === "Out of Stock" ? <span className="text-red-500">{rowInfo.row.original.col4}</span> : <span>{rowInfo.row.original.col4}</span>}
                            <br />
                            {rowInfo.row.original.col12 === "yes" && rowInfo.row.original.col4 != "Out of Stock" ? (
                                <>
                                    <br />
                                    <span className="bg-red-600 px-2 py-2 text-white text-center cursor-pointer" onClick={() => openPromo(rowInfo.row.original.col13)}>
                                        On Promotion !
                                    </span>
                                </>
                            ) : (
                                ""
                            )}

                            {rowInfo.row.original.col23 !== "" &&
                                rowInfo.row.original.col12 !== "yes" &&
                                rowInfo.row.original.col4 !== "Out of Stock" &&
                                parseFloat(rowInfo.row.original.col23.replace("R ", "")) < parseFloat(rowInfo.row.original.col5.replace("R ", "")) ? (
                                <>
                                    <br />
                                    <span className="bg-red-600 px-2 py-2 text-white text-center cursor-pointer">On Promotion !</span>
                                </>
                            ) : (
                                ""
                            )}
                        </>
                    );
                },
            },
            {
                Header: ({ column }) => (
                    <div className="flex items-center cursor-pointer" {...column.getSortByToggleProps()}>
                        Price Excl. VAT
                        <span className="ml-1">
                            {column.isSorted ? (column.isSortedDesc ? "▼" : "▲") : "▲▼"}
                        </span>
                    </div>
                ),
                accessor: "col5",
                Cell: (rowInfo) => {
                    return (
                        <>
                            {rowInfo.row.original.col14 == "1" && rowInfo.row.original.col12 === "yes" && rowInfo.row.original.col6 >= rowInfo.row.original.col17 ? (
                                <>
                                    <strike className="text-red-400">R {parseFloat(rowInfo.row.original.col5.replace("R ", "")).toFixed(2)}</strike>
                                    <br />R{" "}
                                    {(
                                        parseFloat(rowInfo.row.original.col5.replace("R ", "")) -
                                        parseFloat(rowInfo.row.original.col5.replace("R ", "")) *
                                        parseFloat("0." + (parseFloat(rowInfo.row.original.col18) > 9 ? rowInfo.row.original.col18 : "0" + rowInfo.row.original.col18))
                                    ).toFixed(2)}
                                </>
                            ) : (
                                <span>
                                    {rowInfo.row.original.col23 !== "" &&
                                        rowInfo.row.original.col23 !== null &&
                                        parseFloat(rowInfo.row.original.col23.replace("R ", "")) < parseFloat(rowInfo.row.original.col5.replace("R ", "")) ? (
                                        <>
                                            <del>{rowInfo.row.original.col5}</del>
                                            <br />
                                            {rowInfo.row.original.col23}
                                        </>
                                    ) : (
                                        <>{rowInfo.row.original.col5}</>
                                    )}

                                    {rowInfo.row.original.col11 == "SD" ? (
                                        <>
                                            <span className="text-green-500 ml-2" data-tip="ACT 36 Settlement Discount if Applicable">
                                                <FontAwesomeIcon icon={faExclamationCircle} />
                                            </span>{" "}
                                            <ReactTooltip />
                                        </>
                                    ) : (
                                        ""
                                    )}
                                </span>
                            )}
                        </>
                    );
                },
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "left",
                        }}
                    >
                        QTY
                    </div>
                ),
                accessor: "col6",
                Cell: (rowInfo) => {
                    const inputRef = createRef();
                    //inputRefs.set(rowInfo.row.original.col2, inputRef);
                    inputRefs.current.set(rowInfo.row.original.col2, inputRef);
                    // console.log(inputRefs);
                    // console.log(rowInfo.row.original.col2);
                    // console.log(rowInfo.row.original.col6);
                    return (
                        <div key={rowInfo.row.original.col2}>
                            <input
                                ref={inputRef}
                                type="number"
                                min="0"
                                defaultValue={rowInfo.row.original.col6}
                                className="shadow-sm text-sm border border_radius_5 w-20"
                                onChange={(e) => {
                                    // parseFloat(e.target.value) < 0
                                    //     ? setTotals(0, rowInfo.row.original.col2, rowInfo.row.original)
                                    //     : setTotals(e.target.value, rowInfo.row.original.col2, rowInfo.row.original);
                                    // e.target.value = Math.abs(e.target.value);
                                    const val = Math.max(0, parseFloat(e.target.value) || 0);
                                    debouncedUpdate(rowInfo.row.original, val);

                                }}
                            />
                        </div>
                    );
                },
            },
            {
                Header: "",
                accessor: "col7",
                Cell: (rowInfo) => {
                    return (
                        <div>
                            {rowInfo.row.original.col12 == "yes" ? (
                                <>
                                    <span
                                        className="px-10 py-2 border border-transparent text-base font-medium border_radius_4 shadow-sm text-white bg-lk_grey_one hover:bg-lk_dark_grey_button_hover uppercase mx-auto cursor-pointer"
                                        disabled={orderPlaced}
                                        onClick={() => RemovePromoItemFromCart(rowInfo.row.original.col2, rowInfo.row.original.col15)}
                                    >
                                        {orderPlaced === true ? "Removing..." : "Remove"}
                                    </span>
                                </>
                            ) : (
                                <>
                                    <span
                                        className="px-10 py-2 border border-transparent text-base font-medium border_radius_4 shadow-sm text-white bg-lk_grey_one hover:bg-lk_dark_grey_button_hover uppercase mx-auto cursor-pointer"
                                        disabled={orderPlaced}
                                        onClick={() => RemoveItemFromCart(rowInfo.row.original.col2)}
                                    >
                                        {orderPlaced === true ? "Removing..." : "Remove"}
                                    </span>
                                </>
                            )}
                        </div>
                    );
                },
            },
        ],
        [toUpdate]
    );

    const tableInstance = useTable({ columns, data, manualPagination: true }, useSortBy, usePagination);

    const { getTableProps, getTableBodyProps, headerGroups, page, nextPage, previousPage, canNextPage, canPreviousPage, prepareRow } = tableInstance;

    async function acceptTnC(itemId, reqAmount, accepted, value) {
        // await setTotals(reqAmount, itemId)

        let acceptedPromotions = JSON.parse(window.sessionStorage.getItem("promotionAccepted"));

        if (acceptedPromotions == null) {
            window.sessionStorage.setItem("promotionAccepted", JSON.stringify([itemId]));
        } else {
            window.sessionStorage.setItem("promotionAccepted", JSON.stringify([...acceptedPromotions, itemId]));
        }

        //overHere

        if (value.target.checked === true) {
            let newAccepted = accepted + 1;
            setTotalAccepted(newAccepted);
        } else {
            let newAccepted = accepted - 1;
            setTotalAccepted(newAccepted);
        }

        await getProducts(1);
    }

    async function PlaceThisOrder(products, orderNo, fullPrice, amountDue, salesperson) {
        console.log(amountDue);
        console.log(fullPrice);
        console.log(products);
        console.log(orderNo);
        console.log(salesperson);
        console.log(currentUser.branch);
        console.log(currentUser.customer_code);
        // Show progress modal
        setIsModalVisible(true);

        // 1) Qty check
        let qtyOK = true;
        Object.keys(products).forEach((key) => {
            if (products[key].col6 <= 0) qtyOK = false;
        });

        if (!qtyOK) {
            setQtyIssue(true);
            alert("Please make sure that all items have a Quantity above 0");
            setIsModalVisible(false);
            return;
        }

        // 2) On-hold (local) only if NOT linked
        const hasLinkedAccounts =
            typeof currentUser.customer_code === "string" &&
            currentUser.customer_code.includes(",");

        if (currentUser.CustomerOnHold === "Y" && !hasLinkedAccounts) {
            dispatch(
                openModal({
                    modalType: "OnHoldModal",
                    modalProps: { type: "cart" },
                })
            );
            setIsModalVisible(false);
            return;
        }

        // 3) Promo acceptance
        if (totalToAccept !== totalAccepted) {
            dispatch(
                openModal({
                    modalType: "OrderFailed",
                    modalProps: {
                        errors: ["Please accept all the promotion terms and conditions"],
                    },
                })
            );
            setIsModalVisible(false);
            return;
        }

        // 4) Script check
        if (scriptUploaded === false && hasScript === true) {
            dispatch(
                openModal({
                    modalType: "ScriptHelp",
                    modalProps: {
                        products: products,
                        setScriptUploaded: setScriptUploaded,
                    },
                })
            );
            setIsModalVisible(false);
            return;
        }

        // Once place-order-data succeeds the order is in Syspro; a failure in
        // any later step (email, finalize) must never be reported to the
        // customer as a failed order - that is how one order became seven
        // duplicates during the 4-9 Sept incidents.
        let orderPosted = false;
        let placedOrderNumbersRaw = null;

        try {
            setOrderPlaced(true);

            // Step 1: Check Backorder
            setProgress((prev) => ({
                ...prev,
                checkingStock: { status: "in-progress", message: "Confirming Stock Availability" },
            }));

            const backorderCheck = await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}check-backorder`,
                headers: { Authorization: `Bearer ${currentUser.token}` },
                data: {
                    branch: currentUser.branch,
                    products,
                    customer_code: currentUser.customer_code || "",
                },
            });

            if (backorderCheck.data.length > 0 && backorderAsk === false) {
                setOrderPlaced(false);
                setProgress((prev) => ({
                    ...prev,
                    checkingStock: { status: "failed", message: "Stock Issues Found" },
                }));
                dispatch(
                    openModal({
                        modalType: "OrderBackorder",
                        modalProps: {
                            backorders: backorderCheck.data,
                            setBackorderAsk: setBackorderAsk,
                            setReRunOrder: setReRunOrder,
                            currentUser: currentUser,
                        },
                    })
                );
                setIsModalVisible(false);
                return;
            }

            setProgress((prev) => ({
                ...prev,
                checkingStock: { status: "completed", message: "Stock Availability Confirmed" },
            }));

            // Step 2: Place Order Session
            setProgress((prev) => ({
                ...prev,
                placingOrder: { status: "in-progress", message: "Placing Order" },
            }));

            const guid = await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}place-order-session`,
                headers: { Authorization: `Bearer ${currentUser.token}` },
                data: { userId: currentUser.id },
            });

            if (guid.data === "offline-system") {
                alert("Currently the system is undergoing maintenance and is not available for placing of orders");
                setIsSubmitting(false);
                setOrderPlaced(false);
                setProgress((prev) => ({
                    ...prev,
                    placingOrder: { status: "failed", message: "Order Placement Failed" },
                }));
                setIsModalVisible(false);
                return;
            }

            const order = await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}place-order-data`,
                headers: {
                    Authorization: `Bearer ${currentUser.token}`,
                    "Access-Control-Allow-Origin": "*",
                },
                data: {
                    userId: currentUser.id,
                    userEmail: currentUser.email,
                    products: products,
                    guid: guid.data,
                    customer_code:
                        currentUser.isCustomer === 1 && currentUser.customer_code !== null
                            ? currentUser.customer_code
                            : currentUser.customer_code === null || currentUser.customer_code.split(",").length > 1
                                ? "None"
                                : currentUser.customer_code,
                    branch: currentUser.branch,
                    orderNo: orderNo,
                    totalPrice: fullPrice,
                    payment_id: window.sessionStorage.getItem("paymentId"),
                    salesperson: salesperson,
                    comment: commentRef.current.value,
                },
            });

            // === NEW: on-hold response ===
            if (Array.isArray(order.data) && order.data[0]?.type === "on_hold") {
                setIsModalVisible(false);
                setOrderPlaced(false);
                dispatch(
                    openModal({
                        modalType: "OnHoldModal",
                        modalProps: {
                            type: "cart",
                            message: order.data[0].message,
                            blockedItems: order.data[0].blocked_items,
                            blockedCustomers: order.data[0].blocked_customers,
                        },
                    })
                );
                return;
            }

            // Existing: order failed
            if (order.data[0] === "Order Failed") {
                dispatch(
                    openModal({
                        modalType: "OrderFailed",
                        modalProps: { errors: order.data[1] },
                    })
                );
                setProgress((prev) => ({
                    ...prev,
                    placingOrder: { status: "failed", message: "Order Placement Failed" },
                }));
                setIsModalVisible(false);
                setOrderPlaced(false);
                return;
            }

            // Existing: repeat suggested
            if (Array.isArray(order.data) && order.data[0]?.type === "repeat_suggested") {
                setIsModalVisible(false);
                dispatch(
                    openModal({
                        modalType: "ConfirmRepeatOrderPlacement",
                        modalProps: {
                            message: order.data[0].message,
                            onConfirm: () => {
                                window.localStorage.setItem("is_repeat_order", "true");
                                PlaceThisOrder(products, orderNo, fullPrice, amountDue, salesperson);
                            },
                        },
                    })
                );
                return;
            }

            // Success
            orderPosted = true;
            placedOrderNumbersRaw = order.data[1];
            setProgress((prev) => ({
                ...prev,
                placingOrder: { status: "completed", message: "Order Placed Successfully" },
            }));

            // === NEW: partial response ===
            const partial = Array.isArray(order.data) ? order.data[2] : null;
            if (partial?.type === "partial") {
                dispatch(
                    openModal({
                        modalType: "OrderPartial",
                        modalProps: partial,
                    })
                );
            }

            // Step 3: Send Email
            setProgress((prev) => ({
                ...prev,
                sendingEmail: { status: "in-progress", message: "Sending Email" },
            }));

            try {
                await axios({
                    method: "post",
                    url: `${process.env.REACT_APP_API_URL}send-mail-order`,
                    headers: { Authorization: `Bearer ${currentUser.token}` },
                    data: {
                        userId: currentUser.id,
                        name: currentUser.ship_addr_1,
                        customer_code:
                            currentUser.isCustomer === 1 && currentUser.customer_code !== null
                                ? currentUser.customer_code
                                : currentUser.customer_code === null || currentUser.customer_code.split(",").length > 1
                                    ? "None"
                                    : currentUser.customer_code,
                        orderItems: products,
                        totalPrice: fullPrice,
                        scriptUploaded: scriptUploaded,
                        order_no: order.data[1],
                        po_no: orderNo,
                        paymentType: paymentType === 1 ? "Credit Card" : "EFT",
                    },
                });

                setProgress((prev) => ({
                    ...prev,
                    sendingEmail: { status: "completed", message: "Email Sent Successfully" },
                }));
            } catch (mailError) {
                // The order is already placed - report the email hiccup and
                // carry on to payment/finalize as normal.
                console.error("Order placed but confirmation email failed:", mailError);
                setProgress((prev) => ({
                    ...prev,
                    sendingEmail: { status: "failed", message: "Confirmation Email Delayed" },
                }));
                toast.warning("Order placed, but the confirmation email could not be sent.");
            }

            // Step 4: Payment
            if (cashPayment === true && creditCardRequired) {
                if (paymentType === 1) {
                    setProgress((prev) => ({
                        ...prev,
                        cashPayment: { status: "in-progress", message: "Creating payment" },
                    }));
                    const this_pay_value = amountDue;
                    window.location.href = `${process.env.REACT_APP_API_URL}paym8-create-payment/${this_pay_value}/${currentUser.customer_code}/${order.data[1]}/${currentUser.id}/${payM8Privacy}`;
                    return;
                } else {
                    setProgress((prev) => ({
                        ...prev,
                        cashPayment: { status: "completed", message: "EFT Payment" },
                    }));
                }
            }

            // Finalize
            window.sessionStorage.setItem("itemsInBasket", 0);
            window.sessionStorage.setItem("itemsIdsInBasket", JSON.stringify([]));
            window.sessionStorage.setItem("totalItemsInBasket", JSON.stringify([]));
            window.sessionStorage.setItem("itemsClicked", JSON.stringify([]));
            window.sessionStorage.setItem("promotionAccepted", JSON.stringify([]));

            dispatch(getCartTotal(currentUser));

            const placedOrderNosRaw = order.data[1];
            const placedOrderNos = Array.isArray(placedOrderNosRaw)
                ? placedOrderNosRaw
                : placedOrderNosRaw
                    ? [placedOrderNosRaw]
                    : [];

            window.sessionStorage.setItem("placedOrderNos", JSON.stringify(placedOrderNos));
            window.sessionStorage.setItem("placedOrderNosUser", String(currentUser.id));

            setTimeout(() => {
                setIsModalVisible(false);
                toast.success("Order placed successfully!");
                history.push("/order/" + order.data[1][0]);
            }, 1500);
        } catch (error) {
            console.error("Error placing order:", error);
            setIsModalVisible(false);

            if (orderPosted) {
                // place-order-data succeeded, so the order is in Syspro -
                // only a follow-up step (email/finalize) blew up. Never tell
                // the customer the order failed.
                const nos = Array.isArray(placedOrderNumbersRaw)
                    ? placedOrderNumbersRaw
                    : placedOrderNumbersRaw
                        ? [placedOrderNumbersRaw]
                        : [];
                toast.success("Order placed successfully!");
                if (nos[0]) {
                    history.push("/order/" + nos[0]);
                }
            } else if (!error.response || error.response.status === 502 || error.response.status === 504) {
                // No response / gateway timeout: the server may still be
                // finishing the order. Blind retries here are what created
                // duplicate orders during the Sept incidents.
                setProgress((prev) => ({
                    ...prev,
                    placingOrder: { status: "failed", message: "Order Status Unconfirmed" },
                }));
                toast.error(
                    "We could not confirm whether your order was placed. Please check My Orders before trying again."
                );
            } else {
                setProgress((prev) => ({
                    ...prev,
                    placingOrder: { status: "failed", message: "An Error Occurred" },
                }));
                toast.error("Failed to place order. Please try again.");
            }
        } finally {
            window.localStorage.removeItem("is_repeat_order");
        }
    }


    let textGray = "text-gray-400 mx-auto text-center relative px-2 py-2 text-sm";

    async function createScriptTemplate(orderItems, freeProducts) {
        let script = await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}create-script-template`,
            headers: { Authorization: `Bearer ${currentUser.token}` },
            data: {
                userId: currentUser.id,
                name: currentUser.ship_addr_1,
                // name: currentUser.name + " " + currentUser.last_name,
                customer_code:
                    currentUser.isCustomer === 1 && currentUser.customer_code !== null
                        ? currentUser.customer_code
                        : currentUser.customer_code === null || currentUser.customer_code.split(",").length > 1
                            ? "None"
                            : currentUser.customer_code,
                orderItems: [orderItems, freeProducts].flat(),
            },
        });
        window.open(process.env.REACT_APP_URL + "scripts/" + script.data, "_blank").focus();
    }

    async function createQuote(orderItems, freeProducts, fullPrice, type) {
        if (type === "pdf") {
            let script = await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}create-quote-pdf`,
                headers: { Authorization: `Bearer ${currentUser.token}` },
                data: {
                    userId: currentUser.id,
                    name: currentUser.ship_addr_1,
                    // name: currentUser.name + " " + currentUser.last_name,
                    customer_code:
                        currentUser.isCustomer === 1 && currentUser.customer_code !== null
                            ? currentUser.customer_code
                            : currentUser.customer_code === null || currentUser.customer_code.split(",").length > 1
                                ? "None"
                                : currentUser.customer_code,
                    orderItems: [orderItems, freeProducts].flat(),
                    totalPrice: fullPrice,
                },
            });
            window.open(process.env.REACT_APP_URL + "quotes/" + script.data, "_blank").focus();
        } else {
            let script = await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}create-quote-excel`,
                headers: { Authorization: `Bearer ${currentUser.token}` },
                data: {
                    userId: currentUser.id,
                    name: currentUser.ship_addr_1,
                    customer_code:
                        currentUser.isCustomer === 1 && currentUser.customer_code !== null
                            ? currentUser.customer_code
                            : currentUser.customer_code === null || currentUser.customer_code.split(",").length > 1
                                ? "None"
                                : currentUser.customer_code,
                    orderItems: freeProducts.length > 0 ? [orderItems, freeProducts].flat() : orderItems,
                    totalPrice: fullPrice,
                },
            });

            window.open(process.env.REACT_APP_URL + script.data, "_blank").focus();
        }
    }
    async function addNewItems() {

        // setOrderPlaced(true);
        // var formData = new FormData();
        // var imagefile = document.querySelector("#importCart");

        // formData.append("file", imagefile.files[0]);
        // formData.append("userId", currentUser.id);
        // formData.append("customer_code", currentUser.customer_code);

        // await axios.post(
        //     `${process.env.REACT_APP_API_URL}import-to-cart`,
        //     formData,
        //     {
        //         headers: {
        //             Authorization: `Bearer ${currentUser.token}`,
        //             "Content-Type": "multipart/form-data",
        //         },
        //     }).then(async (response) => {
        //         console.log("response: ", response.data);
        //         if (response.data.status === "error") {
        //             setImportData(response.data);
        //             setImportModalVisible(true);
        //             await getProducts(0); // Refresh product list
        //             dispatch(getCartTotal(currentUser));
        //             setOrderPlaced(false);
        //             return;
        //         } else {
        //             setImportData({ status: "success" });
        //             setImportModalVisible(true);
        //             setTimeout(() => {
        //                 setImportModalVisible(false);
        //                 setImportData(null);
        //             }, 1500);
        //             await getProducts(0); // Refresh product list
        //             dispatch(getCartTotal(currentUser));
        //             setOrderPlaced(false);
        //         }
        //     }).then(async () => {
        //         dispatch(getCartTotal(currentUser));
        //     }).then(() => {
        //         setOrderPlaced(false);
        //     }).catch((error) => {
        //         console.error("Error importing file:", error.response ? error.response.data : error);
        //         if (error.response && error.response.status === 400) {
        //             setImportData(error.response.data);
        //         } else {
        //             setImportData({ status: "error", message: "An unexpected error occurred." });
        //         }
        //         setImportModalVisible(true);
        //         setOrderPlaced(false);
        //     });

        try {
            setOrderPlaced(true);
            var formData = new FormData();
            var imagefile = document.querySelector("#importCart");

            formData.append("file", imagefile.files[0]);
            formData.append("userId", currentUser.id);
            formData.append("customer_code", currentUser.customer_code);

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}import-to-cart`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${currentUser.token}`,
                        "Content-Type": "multipart/form-data",
                    },
                });

            //console.log("Success:", response.data);
            if (response.data.status === "error") {
                setImportData(response.data);
                setImportModalVisible(true);
                return;
            }
            setImportData({ status: "success" });
            setImportModalVisible(true);
            setTimeout(() => {
                setImportModalVisible(false);
                setImportData(null);
            }, 1500);

        } catch (error) {
            // console.error("Error importing file:", error.response ? error.response.data : error);
            if (error.response && error.response.status === 400) {
                setImportData(error.response.data);
            } else {
                setImportData({ status: "error", message: "An unexpected error occurred." });
            }
            setImportModalVisible(true);
            setOrderPlaced(false);
        } finally {
            await getProducts(0); // Refresh product list
            dispatch(getCartTotal(currentUser));
            setOrderPlaced(false);
        }
    }


    async function uploadScript(file) {
        var formData = new FormData();
        var imagefile = document.querySelector("#uploadFile");
        formData.append("file", imagefile.files[0]);
        formData.append("userId", currentUser.id);
        formData.append("customer_code", currentUser.customer_code);

        let script = await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}upload-script`,
            headers: {
                Authorization: `Bearer ${currentUser.token}`,
                "Content-Type": "multipart/form-data",
            },
            data: formData,
        });

        setScriptUploaded(script.data);
    }

    return (
        <div className="bg-gray-50">
            <AdminSearchForm
                heading="Cart"
                color="text-gray-500"
                header_color="bg-gradient-to-b from-gray-300"
                crumb_color="text-black"
                breadcrumbs={[
                    { name: "Home", href: "/", count: 1 },
                    { name: "Shop", href: "/shop", count: 2 },
                    { name: "My Cart", href: "/view-cart", count: 3 },
                ]}
            />

            <br />
            <br />

            <div className="container mx-auto">
                <CustomButton
                    disabled={orderPlaced}
                    submitBool={orderPlaced}
                    type="button"
                    text="Make template"
                    className="inline-flex items-right px-12 py-2 ml-3 border border-transparent text-base font-medium border_radius_4 shadow-sm text-white bg-lk_red hover:bg-lk_red_hover uppercase"
                    // onClick={() => PlaceThisOrder(products)}
                    onClick={() => createTemplate(products)}
                    data-tip="Make template"
                />
                <CustomButton
                    disabled={orderPlaced}
                    submitBool={orderPlaced}
                    type="button"
                    text="Print Quote PDF"
                    className="inline-flex items-right px-12 py-2 ml-3 border border-transparent text-base font-medium border_radius_4 shadow-sm text-white bg-lk_red hover:bg-lk_red_hover uppercase"
                    // onClick={() => PlaceThisOrder(products)}
                    onClick={() => createQuote(products, freeProducts, totalPrice, "pdf")}
                    data-tip="Print Quote PDF"
                />
                <CustomButton
                    disabled={orderPlaced}
                    submitBool={orderPlaced}
                    type="button"
                    text="Print Quote Excel"
                    className="inline-flex items-right px-12 py-2 ml-3 border border-transparent text-base font-medium border_radius_4 shadow-sm text-white bg-lk_red hover:bg-lk_red_hover uppercase"
                    // onClick={() => PlaceThisOrder(products)}
                    onClick={() => createQuote(products, freeProducts, totalPrice, "excel")}
                    data-tip="Print Quote Excel"
                />

                {hasScript === true && (
                    <button
                        className="inline-flex items-right px-12 py-2 ml-3 border border-transparent text-base font-medium border_radius_4 shadow-sm text-white bg-lk_red hover:bg-lk_red_hover uppercase"
                        onClick={() => createScriptTemplate(products, freeProducts)}
                    >
                        Print Script Template
                    </button>
                )}


                <CustomButton
                    disabled={orderPlaced}
                    submitBool={orderPlaced}
                    type="submit"
                    text="Import Cart"
                    className="inline-flex items-right px-12 py-2 ml-3 border border-transparent text-base font-medium border_radius_4 shadow-sm text-white bg-blue-500 hover:bg-blue-700 uppercase"
                    // onClick={() => PlaceThisOrder(products)}
                    onClick={() => document.getElementById("importCart").click()}
                    data-tip="Stock Code in column A, Quantity in column B"
                />
                <input
                    id="importCart"
                    name="importCart"
                    type="file"
                    style={{ display: "none" }}
                    onChange={(event) => {
                        addNewItems(event.target.files[0]);
                    }}
                    className="form-control"
                />
                <ReactTooltip />
                {products.length > 0 && (
                    <CustomButton
                        disabled={orderPlaced}
                        submitBool={orderPlaced}
                        type="button"
                        text="Empty Cart"
                        className="inline-flex items-right px-12 py-2 ml-3 border border-transparent text-base font-medium border_radius_4 shadow-sm text-white bg-lk_red hover:bg-lk_red_hover uppercase"
                        // onClick={() => PlaceThisOrder(products)}
                        onClick={() => emptyCart()}
                        data-tip="Remove all items from cart"
                    />
                )}

                <table
                    {...getTableProps()}
                    className="mb-10 w-full"
                    style={{
                        borderCollapse: "separate",
                        borderSpacing: "0 1em",
                    }}
                >
                    <thead className="sticky top-32 lg:top-40 md:top-44 sm:top-48 z-10">
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()} className="bg-gray-100 flex flex-col flex-no wrap sm:table-row w-full">
                                {headerGroup.headers.map((column) => (
                                    <th {...column.getHeaderProps(column.getSortByToggleProps())} className="px-2 py-2 font-light">
                                        {column.render("Header")}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                            prepareRow(row);
                            return (
                                <>
                                    <tr {...row.getRowProps()} className="bg-white rounded mt-5 flex flex-col flex-no wrap sm:table-row">
                                        {row.cells.map((cell) => {
                                            return (
                                                <>
                                                    <td
                                                        {...cell.getCellProps()}
                                                        style={{
                                                            // borderRight:
                                                            // "1px solid #EFEFEF",
                                                            textAlign: "left",
                                                        }}
                                                        className="mx-auto text-center relative px-2 py-2 text-sm lg:border-r md:border-r border-slate-300"
                                                    >
                                                        {cell.render("Cell").props.cell.column.id === "col2" || cell.render("Cell").props.cell.column.id === "col4" ? (
                                                            <p
                                                                className="text-gray-500 text-2xl lg:text-sm md:text-sm"
                                                                style={{
                                                                    textAlign: "left",
                                                                }}
                                                            >
                                                                {cell.render("Cell")}
                                                            </p>
                                                        ) : (
                                                            <>
                                                                {cell.render("Cell").props.cell.column.id === "col3" ? (
                                                                    <p className="text-center lg:text-left md:text-left">{cell.render("Cell")}</p>
                                                                ) : (
                                                                    cell.render("Cell")
                                                                )}
                                                            </>
                                                            // cell.render("Cell")
                                                        )}
                                                    </td>
                                                </>
                                            );
                                        })}
                                    </tr>

                                    {/* {row.original.col12 == "yes" && (
                              <tr role="row" className="mt-0">
                                <td colSpan="7">
                                  <p className="ml-5">A salesperson will contact you to apply this promotion</p>
                                </td>
                              </tr>
                            )} */}
                                </>
                            );
                        })}
                    </tbody>
                </table>

                <ToastContainer />

                {/* Progress Modal */}
                <ProgressModal isVisible={isModalVisible} progress={progress} />
                {/* Import Modal */}
                <ImportModal
                    isVisible={isImportModalVisible}
                    importData={importData}
                    onClose={() => {
                        setImportData(null);
                        setImportModalVisible(false);
                    }}
                />

                {unavailableFree.items.length > 0 && (
                    <div className="mb-6 border border-yellow-400 bg-yellow-50 border_radius_10 px-4 py-3 text-sm text-gray-800" role="alert">
                        <p className="font-medium mb-1">
                            {unavailableFree.items.length === 1 ? "A free promotional item isn't" : "Some free promotional items aren't"} available from your branch's warehouse:
                        </p>
                        <ul className="list-disc ml-6 mb-2">
                            {unavailableFree.items.map((item) => (
                                <li key={item.stock_code}>
                                    {item.description} ({item.stock_code}) &times; {item.qty}
                                </li>
                            ))}
                        </ul>
                        <p>
                            {unavailableFree.items.length === 1 ? "It" : "These"} won't be included with this order. Please contact your Lakato sales representative
                            {unavailableFree.sales_rep && unavailableFree.sales_rep.name ? ` (${unavailableFree.sales_rep.name})` : ""} for assistance
                            {unavailableFree.sales_rep && unavailableFree.sales_rep.email ? (
                                <>
                                    {" "}at{" "}
                                    <a className="underline" href={`mailto:${unavailableFree.sales_rep.email}`}>
                                        {unavailableFree.sales_rep.email}
                                    </a>
                                </>
                            ) : null}
                            .
                        </p>
                    </div>
                )}

                {freeProducts.length > 0 && (
                    <>
                        <CustomButton disabled={true} type="button" text="Specials" className="bg-gray-300 w-full border_radius_10 mb-5 px-4 py-3 uppercase" />

                        <table
                            className="mb-10 w-full"
                            style={{
                                borderCollapse: "separate",
                                borderSpacing: "0 1em",
                            }}
                        >
                            <thead>
                                {headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()} className="bg-gray-100">
                                        {headerGroup.headers.map((column) => (
                                            <th {...column.getHeaderProps(column.getSortByToggleProps())} className="px-2 py-5 font-light">
                                                {column.render("Header")}
                                            </th>
                                        ))}
                                    </tr>
                                ))}
                            </thead>
                            <tbody>
                                {freeProducts.map((free) => (
                                    <>
                                        {/* {free.col20 == 'yes' ? } */}
                                        <tr role="row" className="bg-white rounded mt-5" key={new Date()}>
                                            {/* <td
                                                role="cell"
                                                style={{
                                                    borderRight:
                                                        "1px solid #EFEFEF",
                                                    textAlign: "left",
                                                }}
                                                className={
                                                    free.col20 == "yes"
                                                        ? textGray
                                                        : "mx-auto text-center relative px-2 py-2 text-sm"
                                                }
                                            ></td> */}
                                            <td></td>
                                            <td
                                                role="cell"
                                                style={{
                                                    borderRight: "1px solid #EFEFEF",
                                                    textAlign: "left",
                                                }}
                                                className={free.col20 == "yes" ? textGray : "mx-auto text-center relative px-2 py-2 text-sm"}
                                            >
                                                {free.col0}
                                            </td>
                                            <td
                                                role="cell"
                                                style={{
                                                    borderRight: "1px solid #EFEFEF",
                                                    textAlign: "left",
                                                }}
                                                className={free.col20 == "yes" ? textGray : "mx-auto text-center relative px-2 py-2 text-sm"}
                                            >
                                                {free.col3}
                                                <br />
                                                {free.col8}
                                            </td>
                                            <td
                                                role="cell"
                                                style={{
                                                    borderRight: "1px solid #EFEFEF",
                                                    textAlign: "left",
                                                }}
                                                className={free.col20 == "yes" ? textGray : "mx-auto text-center relative px-2 py-2 text-sm"}
                                            >
                                                {free.col4}
                                            </td>
                                            <td
                                                role="cell"
                                                style={{
                                                    borderRight: "1px solid #EFEFEF",
                                                    textAlign: "left",
                                                }}
                                                className={free.col20 == "yes" ? textGray : "mx-auto text-center relative px-2 py-2 text-sm"}
                                            >
                                                {console.log(free)}
                                                {free.col20 === "no" || free.col20 === '"no"' ? (
                                                    <>{free.col5}</>
                                                ) : (
                                                    <>
                                                        <strike className="text-red-400">{free.col5}</strike>
                                                        <br />R 0
                                                    </>
                                                )}
                                            </td>
                                            <td
                                                role="cell"
                                                style={{
                                                    borderRight: "1px solid #EFEFEF",
                                                    textAlign: "left",
                                                }}
                                                className={free.col20 == "yes" ? textGray : "mx-auto text-center relative px-2 py-2 text-sm"}
                                            >
                                                {/* <input type="number" min='0' disabled={true} defaultValue = {free.col6} className="shadow-sm text-sm border border_radius_5 w-20" onChange={(values) => {parseFloat(values.target.value) < 0 ? setTotals(0, free.col0) : setTotals(values.target.value, free.col0); getProducts(); values.target.value = Math.abs(values.target.value);}}/>  */}
                                                {free.col6}
                                            </td>
                                            <td
                                                role="cell"
                                                style={{
                                                    borderRight: "1px solid #EFEFEF",
                                                    textAlign: "left",
                                                }}
                                                className={free.col20 == "yes" ? textGray : "mx-auto text-center relative px-2 py-2 text-sm"}
                                            >
                                                <span>
                                                    {" "}
                                                    {free.col17} + {free.col19} deal.
                                                </span>
                                            </td>
                                        </tr>
                                        {free.col20 === "no" && (
                                            <tr>
                                                <td colSpan="5">
                                                    <span>
                                                        Order {free.col17}x of the following{" "}
                                                        <span className="cursor-pointer text-blue-600" onClick={() => openPromo(free.col13)}>
                                                            qualifying products
                                                        </span>{" "}
                                                        you will receive {free.col19}, to be given away FREE with the sale of the{" "}
                                                        <span className="cursor-pointer text-blue-600" onClick={() => openPromo(free.col13)}>
                                                            qualifying product
                                                        </span>
                                                        . You may <br />
                                                        order more than one deal but you will need to buy in multiples of {free.col17} units
                                                    </span>
                                                </td>
                                                <td colSpan="2">
                                                    {free.col22 === 1 && (
                                                        <>
                                                            <input type="checkbox" onChange={(value) => acceptTnC(free.col2, free.col14, totalAccepted, value)} /> I accept the terms and conditions
                                                        </>
                                                    )}
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                ))}
                            </tbody>
                            {/* freeProducts */}
                        </table>
                    </>
                )}
            </div>
            {/* {cartHasPromo == 1 && (
               <div className="container mx-auto flex flex-row-reverse mb-10">
                  <label>
                    <input type="checkbox" className="mr-2" onClick={(value) => {
                      setContactUser(value.target.checked)
                      }}/>
                    Would you like to have a salesperson contact you to ensure your order is correct?
                  </label>
                </div>
            )} */}

            <div className="container mx-auto grid grid-cols-2">
                <div>
                    <label className="block" htmlFor="comment">
                        Comment (Optional)
                    </label>
                    <textarea name="comment" rows="5" className="w-full" ref={commentRef} maxLength="100"></textarea>
                </div>

                <div>
                    {products.length > 0 && (
                        <>
                            {/* Conditional extra credit info */}
                            {termsCode == 2 && hasCredit && (
                                <div className="flex gap-4 px-4 py-3">
                                    <div className="flex justify-end w-full">
                                        <div>
                                            <h2 className="text-lg font-bold mr-5">Available Credit:</h2>
                                            <span className="text-lg font-bold">
                                                R {(parseFloat(creditAvailable) - parseFloat(uninvoiced)).toFixed(2)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Totals */}
                            <div className="flex flex-row-reverse mb-2">
                                <div className="grid grid-cols-2 gap-4">
                                    <div className="col-span-2">
                                        {(() => {


                                            return (
                                                <>
                                                    <div className="flex justify-between">
                                                        <h2 className="text-lg font-bold mr-5">Sub Total:</h2>
                                                        <span className="text-lg font-bold">R {parseFloat(totalPrice).toFixed(2)}</span>
                                                    </div>
                                                    <div className="flex justify-between">
                                                        <h2 className="text-lg font-bold mr-5">VAT:</h2>
                                                        <span className="text-lg font-bold">R {(parseFloat(totalPrice) * 0.15).toFixed(2)}</span>
                                                    </div>

                                                    {/* Extra fields only when credit is applicable */}
                                                    {termsCode == 2 && hasCredit && (
                                                        <>
                                                            <div className="flex justify-between">
                                                                <h2 className="text-lg font-bold mr-5">Invoice Total:</h2>
                                                                <span className="text-lg font-bold">R {(parseFloat(totalPrice) * 1.15).toFixed(2)}</span>
                                                            </div>
                                                            <div className="flex justify-between">
                                                                <h2 className="text-lg font-bold mr-5">Credit Applied:</h2>
                                                                <span className="text-lg font-bold ">R {creditLeft}</span>
                                                            </div>
                                                        </>
                                                    )}

                                                    <div className="flex justify-between">
                                                        <h2 className="text-lg font-bold mr-5">Amount Due:</h2>
                                                        <span className="text-lg font-bold ">R {amountDue}</span>
                                                    </div>
                                                </>
                                            );
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </>

                    )}

                    {products.length > 0 && (
                        <div className="flex flex-row-reverse mb-2">
                            <input type="text" onChange={(v) => window.sessionStorage.setItem("po_no", v.target.value)} maxlength="30" />
                            <label style={{ fontSize: "14px", lineHeight: "16px" }} className="mt-2 mr-2">
                                Purchase order number:
                                <br />
                                <span
                                    style={{
                                        fontSize: "10px",
                                        lineHeight: "12px",
                                    }}
                                >
                                    30 characters max
                                </span>
                            </label>
                        </div>
                    )}

                    {(currentUser.isLakato === 1 || currentUser.isAdmin === 1) && salespeople.length > 0 && (
                        <div className="flex flex-row-reverse items-center mb-2">
                            <select name="salesperson" onChange={(v) => window.sessionStorage.setItem("salesperson", v.target.value)}>
                                <option value="">Don't Override</option>

                                {salespeople?.map((sp) => (
                                    <option value={sp.Salesperson}>{sp.Name}</option>
                                ))}
                            </select>
                            <label
                                style={{
                                    fontSize: "14px",
                                    lineHeight: "16px",
                                }}
                                className="mt-2 mr-2"
                            >
                                Override Salesperson:
                            </label>
                        </div>
                    )}

                    <div className="text-right">{scriptUploaded !== false && <p>Script Uploaded: {scriptUploaded}</p>}</div>

                    <div className="flex flex-row-reverse">
                        {qtyIssue === true ? (
                            <p
                                style={{
                                    color: "red",
                                    fontWeight: "bold",
                                    marginBottom: "20px",
                                }}
                            >
                                Error, you have items with a 0 QTY
                            </p>
                        ) : (
                            <>
                                {products.length > 0 && (
                                    <div>
                                        {cashPayment === true && creditCardRequired && (
                                            <div className="flex items-center justify-end mb-3 space-x-2">
                                                <input name="paymentType" type="radio" value="1" checked={paymentType === 1 ? true : false} onClick={() => setPaymentType(1)} />
                                                <label className="pr-6">Credit Card</label>

                                                <input name="paymentType" type="radio" value="2" checked={paymentType === 2 ? true : false} onClick={() => setPaymentType(2)} />
                                                <label>EFT</label>
                                            </div>
                                        )}

                                        {cashPayment === true && paymentType === 2 && creditCardRequired && (
                                            <div className="mb-3 max-w-sm">
                                                <strong>
                                                    Lakato (Pty) Ltd
                                                    <br />
                                                    Standard Bank
                                                </strong>
                                                <br />
                                                <strong>EFT Branch Code:</strong> 051 001
                                                <br />
                                                <strong>Account No:</strong> 000 633 860
                                                <br />
                                                <strong>Reference:</strong> Your account number
                                                <br />
                                                <strong>Kindly note:</strong> Transfers from a Standard bank account will reflect on the same day. All other banks could take up to two days to reflect.
                                                <br />
                                                <strong>Please email proof of payment to:</strong> debtors@lakato.co.za
                                            </div>
                                        )}

                                        {cashPayment === true && paymentType === 1 && creditCardRequired && (
                                            <>
                                                <div className="flex items-center justify-end mb-3 space-x-2">
                                                    <input name="payM8Privacy" type="checkbox" value="1" checked={payM8Privacy} onChange={() => setPayM8Privacy(payM8Privacy == true ? false : true)} />
                                                    <label className="mr-3">Store Credit Card details</label>
                                                </div>

                                                <div className="mb-3 max-w-sm">
                                                    *For Credit Card Payments you will be redirected to a secure site that will process your transaction.
                                                    <br />
                                                    *Diners and Amex cards not accepted.
                                                </div>
                                            </>
                                        )}

                                        <div className="flex items-center justify-end mb-3 max-w-lg">
                                            <CustomButton
                                                disabled={orderPlaced}
                                                submitBool={orderPlaced}
                                                type="submit"
                                                text="Place Order"
                                                className="lkbutton bg-lk_red hover:bg-lk_red_hover w-52 border_radius_10 mb-5"
                                                onClick={() =>
                                                    PlaceThisOrder([products, freeProducts].flat(), window.sessionStorage.getItem("po_no"), totalPrice, amountDue, window.sessionStorage.getItem("salesperson"))
                                                }
                                            />
                                        </div>
                                    </div>
                                )}
                            </>
                        )}

                        {hasScript === true && scriptUploaded === false && (
                            <>
                                <CustomButton
                                    disabled={orderPlaced}
                                    submitBool={orderPlaced}
                                    type="submit"
                                    text="Upload Script"
                                    className="lkbutton bg-blue-500 hover:bg-blue-700 w-52 border_radius_10 mb-5 mr-10"
                                    // onClick={() => PlaceThisOrder(products)}
                                    onClick={() => document.getElementById("uploadFile").click()}
                                />
                                <input
                                    id="uploadFile"
                                    name="uploadFile"
                                    type="file"
                                    style={{ display: "none" }}
                                    onChange={(event) => {
                                        uploadScript(event.target.files[0]);
                                    }}
                                    className="form-control"
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
